import { WizardModel } from 'src/containers/onboarding/state/wizard/models/wizard-model';
import { ShowPageLoaderMessage } from '../messages/show-page-loader-message';
import { HidePageLoaderMessage } from '../messages/hide-page-loader-message';
import { WizardMessageNames } from '../wizard-message-names';
import { WizardModelNames } from '../wizard-model-names';

export const wizardReducer = {
  apply: (message: ShowPageLoaderMessage | HidePageLoaderMessage, model: WizardModel) => {
    switch (message.name) {
      case WizardMessageNames.SHOW_PAGE_LOADER:
        const newModelShow: WizardModel = {
          ...model,
          pageLoaderEnabled: true,
        };

        return {
          model: newModelShow,
        };

      case WizardMessageNames.HIDE_PAGE_LOADER:
        const newModelHide: WizardModel = {
          ...model,
          pageLoaderEnabled: false,
        };

        return {
          model: newModelHide,
        };
    }

    return {};
  },
  applicableMessageNames: [WizardMessageNames.SHOW_PAGE_LOADER, WizardMessageNames.HIDE_PAGE_LOADER],
  applicableModelNames: [WizardModelNames.WIZARD],
};
